import { getPartnerConfig } from '@/utils'
import babylonConfig from './babylonConfig'

const { initialState } = window
const partner = initialState?.partner || getPartnerConfig()

export default {
  ...initialState,
  ...babylonConfig,
  partner,
}
